import React from 'react';

const h = React.createElement;

/**
 * Card slots. Card > CardHeader(CardTitle, CardActions) > CardContent > CardFooter.
 *
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {React.CSSProperties} [p.style]
 */
export function CardHeader({ children, style }) { return h('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 12, minWidth: 0, ...style } }, children); }
